/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { media } from '@atlaskit/primitives/responsive/media'` instead.
 */

export { media } from './media';
/**
 * @deprecated Use `import { UNSAFE_media } from '@atlaskit/primitives/media-helper/default'` instead.
 */
export { UNSAFE_media } from './media-helper';
/**
 * @deprecated Use `import { UNSAFE_buildAboveMediaQueryCSS } from '@atlaskit/primitives/responsive/build-media-query-css'` instead.
 */
export { UNSAFE_buildAboveMediaQueryCSS } from './unsafe-build-above-media-query-css';
/**
 * @deprecated Use `import { UNSAFE_BREAKPOINTS_ORDERED_LIST, UNSAFE_BREAKPOINTS_CONFIG } from '@atlaskit/primitives/constants'` instead.
 */
export { UNSAFE_BREAKPOINTS_ORDERED_LIST, UNSAFE_BREAKPOINTS_CONFIG } from './constants';

/**
 * @deprecated Use `import type { Breakpoint, ResponsiveObject, ResponsiveCSSObject, MediaQuery } from '@atlaskit/primitives/responsive/types'` instead.
 */
export type { Breakpoint, ResponsiveObject, ResponsiveCSSObject, MediaQuery } from './types';

/**
 * @deprecated Use `import { UNSAFE_useMediaQuery } from '@atlaskit/primitives/responsive/use-media-query'` instead.
 */
export { UNSAFE_useMediaQuery } from './use-media-query';

/**
 * @deprecated Use `import { Show } from '@atlaskit/primitives/responsive/show'` instead.
 */
export { Show } from './show';
/**
 * @deprecated Use `import { Hide } from '@atlaskit/primitives/responsive/hide'` instead.
 */
export { Hide } from './hide';
